import React, { useState, useRef, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import { AsyncPaginate } from 'react-select-async-paginate';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "jspdf-autotable";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const AgingAnalysis = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [tanentList, setTanentList] = useState([]);
    const [propertyList, setPropertyList] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const ITEMS_PER_PAGE = 100
    const { currencyPrecision } = useCurrency();
    const gridRef = useRef();

    const [formData, setFormData] = useState({
        property: "",
        unitNo: "",
        asOf: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setFormData((prev) => ({ ...prev, asOf: formattedDate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties,LRSearchCustomerName');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)
            setTanentList(res?.data?.dropdowns?.CustomerName);

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setExportData(null)
            setLoader(true)
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            let fromdate = moment(formData?.asOf || formattedDate).format("DD-MMM-YYYY");
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("PropertyName", formData?.property?.label || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            params.append("BasedOn", "0");
            params.append("AsOn", fromdate);

            const res = await apiService.getApiParamater("REPORT_AGEING_ANALYSIS", `?${params.toString()}`);

            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            let fromdate = moment(formData?.asOf || formattedDate).format("DD-MMM-YYYY");
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("PropertyName", formData?.property?.label || "All");
            params.append("UnitNo", formData?.unitNo?.label || "All");
            params.append("BasedOn", "0");
            params.append("AsOn", fromdate);

            const res = await apiService.getApiParamater("REPORT_AGEING_ANALYSIS", `?${params.toString()}`);

            if (res?.data?.result) {
                setExportData(res?.data?.result || []);
                setLoader(false)
            } else {
                setLoader(false)
            }
        } catch (error) {
            console.error("Error fetching items:", error);
            setLoader(false)
        }
    }
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setUnitList([])
        setExportData([])
        setRowData([])
        setFormData({
            property: "",
            unitNo: "",
            asOf: todate,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "property") {
            setFormData(prev => ({ ...prev, unitNo: null }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'LRAgreehUnitNosByPropertyId');
            params.append('CascadValue', value?.value?.value);
            const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
            setUnitList(res?.data?.items)
        } else {
            const cusparams = new URLSearchParams();
            cusparams.append('DropdownFor', 'LRASearchCustByPropertyIdAndUnit');
            cusparams.append('CascadValue', formData?.property?.value?.value);
            cusparams.append('CascadText', value?.value?.value);
            const cusRes = await apiService.getApiParamater('REPORT_CASCAD', `?${cusparams.toString()}`);

        }
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const prepareGridData = (data) => {
        const grouped = {};

        data.forEach((item) => {
            const key = `${item.customerNo}_${item.leaseNo}`;

            if (!grouped[key]) {
                grouped[key] = {
                    customerName: item.customerName,
                    customerNo: item.customerNo,
                    propertyName: item.propertyName,
                    unitNo: item.unitNo,
                    leaseNo: item.leaseNo,
                    status: item.status,
                    overDuedaysCnt: item.overDuedaysCnt,
                    dueDate: item.dueDate,
                    totalSum: item.totalSum,
                    totalReceived: item.totalReceived,
                    totalBalance:
                        item.totalSum - item.totalReceived,

                    // initialize
                    outstanding: 0,
                };
            }

            // Dynamic bucket column
            grouped[key][item.colName] = item.amount;

            // Outstanding = Sum of all bucket amounts
            grouped[key].outstanding += Number((item.amount || 0)?.toFixed(currencyPrecision?.decimalNumbers || 3));
        });

        return Object.values(grouped);
    };
    const getBucketColumns = (data) => {
        const buckets = [
            ...new Map(
                data.map((item) => [
                    item.colOrder,
                    {
                        headerName: item.colName,
                        field: item.colName,
                        colOrder: item.colOrder,
                    },
                ])
            ).values(),
        ];

        return buckets
            .sort((a, b) => a.colOrder - b.colOrder)
            .map((bucket) => ({
                headerName: bucket.headerName,
                field: bucket.field,
                width: 150,
                type: "numericColumn",
                valueFormatter: (params) => (Number(params.value || 0)?.toFixed(currencyPrecision?.decimalNumbers || 3)),
            }));
    };
    const gridData = prepareGridData(rowData);
    const exportGridData = prepareGridData(exportData || []);
    const bucketColumns = getBucketColumns(rowData);
    const columnDefs = [
        {
            headerName: "Name",
            field: "customerName",
            pinned: "left",
            width: 250,
        },
        {
            headerName: "Customer No",
            field: "customerNo",
            width: 120,
        },
        {
            headerName: "Property",
            field: "propertyName",
            width: 180,
        },
        {
            headerName: "Unit",
            field: "unitNo",
            width: 100,
        },
        {
            headerName: "Lease No",
            field: "leaseNo",
            width: 120,
        },
        {
            headerName: "Status",
            field: "status",
            width: 100,
        },
        {
            headerName: "Due Days Count",
            field: "overDuedaysCnt",
            width: 150,
        },
        {
            headerName: "Due Date",
            field: "dueDate",
            width: 120,
        },
        {
            headerName: "Invoiced",
            field: "totalSum",
            width: 130,
            valueFormatter: (p) =>
                Number(p.value || 0).toFixed(currencyPrecision?.decimalNumbers || 3),
        },
        {
            headerName: "Total Received",
            field: "totalReceived",
            width: 150,
            valueFormatter: (p) =>
                Number(p.value || 0).toFixed(currencyPrecision?.decimalNumbers || 3),
        },
        {
            headerName: "Total Balance",
            field: "totalBalance",
            width: 150,
            valueFormatter: (p) =>
                Number(p.value || 0).toFixed(currencyPrecision?.decimalNumbers || 3),
        },

        ...bucketColumns,

        {
            headerName: "Outstanding",
            field: "outstanding",
            width: 150,
            valueFormatter: (p) => Number(p.value || 0).toFixed(currencyPrecision?.decimalNumbers || 3),
        },
    ];
    const currencyFields = new Set([
        "totalSum",
        "totalReceived",
        "totalBalance",
        "outstanding",
        ...bucketColumns.map((b) => b.field),
    ]);
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        return value;
    };
    const exportExcel = () => {
        if (!exportGridData?.length) {
            toast.warning("No data to export");
            return;
        }

        const exportColumns = columnDefs.map((col) => ({
            header: col.headerName,
            field: col.field,
        }));

        const dataRows = exportGridData.map((item) =>
            exportColumns.map((col) =>
                currencyFields.has(col.field)
                    ? Number(item[col.field]) || 0
                    : normalizeValue(item[col.field])
            )
        );

        const totalsRow = exportColumns.map((col, index) => {
            if (index === 0) return "Total";
            if (currencyFields.has(col.field)) {
                return exportGridData.reduce((sum, item) => sum + (Number(item[col.field]) || 0), 0);
            }
            return "";
        });

        const worksheet = XLSX.utils.aoa_to_sheet([
            ["LEASE AGING ANALYSIS"],
            exportColumns.map((c) => c.header),
            ...dataRows,
            totalsRow,
        ]);

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: exportColumns.length - 1 } },
        ];

        worksheet["!cols"] = exportColumns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map((r) => String(r[i] ?? "").length),
                String(totalsRow[i] ?? "").length
            );
            return { wch: Math.min(Math.max(maxLength + 3, 12), 35) };
        });

        worksheet["!rows"] = [{ hpt: 28 }, { hpt: 30 }];
        worksheet["!freeze"] = { ySplit: 2 };

        const borderStyle = {
            top: { style: "thin", color: { rgb: "FFD9D9D9" } },
            bottom: { style: "thin", color: { rgb: "FFD9D9D9" } },
            left: { style: "thin", color: { rgb: "FFD9D9D9" } },
            right: { style: "thin", color: { rgb: "FFD9D9D9" } },
        };

        const numFmt = `#,##0.${"0".repeat(currencyPrecision?.decimalNumbers || 3)}`;

        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        exportColumns.forEach((column, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF666666" } },
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                border: borderStyle,
            };
        });

        dataRows.forEach((row, r) => {
            exportColumns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;
                const isNumeric = currencyFields.has(col.field);
                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: isNumeric ? "right" : "left" },
                    border: borderStyle,
                };
                if (isNumeric) {
                    cell.t = "n";
                    cell.z = numFmt;
                }
            });
        });

        const totalsRowIndex = dataRows.length + 2;
        exportColumns.forEach((col, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: totalsRowIndex, c })];
            if (!cell) return;
            const isNumeric = currencyFields.has(col.field);
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: "FFF0EDF5" } },
                alignment: { vertical: "center", horizontal: isNumeric ? "right" : "left" },
                border: borderStyle,
            };
            if (isNumeric) {
                cell.t = "n";
                cell.z = numFmt;
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Lease Aging Analysis");
        XLSX.writeFile(workbook, "Lease_Aging_Analysis_Report.xlsx");
    };
    const exportToPDF = () => {
        if (!exportGridData?.length) {
            toast.warning("No data to export");
            return;
        }

        const doc = new jsPDF({
            orientation: "landscape",
            unit: "mm",
            format: "a3", // recommended for this report
        });

        const pageWidth = doc.internal.pageSize.getWidth();

        const displayedColumns = gridRef.current.api
            .getAllDisplayedColumns()
            .map((col) => ({
                header: col.getColDef().headerName,
                dataKey: col.getColDef().field,
            }));

        const rows = exportGridData.map((row) => {
            const obj = {};

            displayedColumns.forEach((col) => {
                let value = row[col.dataKey];

                if (typeof value === "number") {
                    value = value.toLocaleString(undefined, {
                        minimumFractionDigits: 3,
                        maximumFractionDigits: 3,
                    });
                }

                obj[col.dataKey] = value ?? "";
            });

            return obj;
        });

        /* ===== Report Title ===== */

        doc.setFont("helvetica", "bold");
        doc.setFontSize(18);

        doc.text(
            "LEASE AGING ANALYSIS ",
            pageWidth / 2,
            15,
            { align: "center" }
        );

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);

        doc.text(
            `As Of : ${formatDate(formData?.asOf)}`,
            pageWidth / 2,
            22,
            { align: "center" }
        );

        /* ===== Table ===== */

        autoTable(doc, {
            columns: displayedColumns,
            body: rows,

            startY: 30,

            theme: "grid",

            tableWidth: "auto",

            styles: {
                fontSize: 6,
                cellPadding: 1.5,
                halign: "center",
                valign: "middle",
                overflow: "linebreak",
                lineWidth: 0.1,
            },

            headStyles: {
                fillColor: [110, 81, 153], // #6E5199
                textColor: 255,
                fontStyle: "bold",
                fontSize: 6.5,
                halign: "center",
                valign: "middle",
            },

            bodyStyles: {
                fontSize: 5.5,
            },

            alternateRowStyles: {
                fillColor: [248, 248, 248],
            },

            margin: {
                top: 30,
                left: 10,
                right: 10,
                bottom: 15,
            },

            didDrawPage: function (data) {
                const pageNumber =
                    doc.internal.getCurrentPageInfo().pageNumber;

                const totalPages =
                    doc.internal.getNumberOfPages();

                doc.setFontSize(8);

                doc.text(
                    `Generated : ${new Date().toLocaleString()}`,
                    10,
                    doc.internal.pageSize.height - 5
                );

                doc.text(
                    `Page ${pageNumber} of ${totalPages}`,
                    doc.internal.pageSize.width - 10,
                    doc.internal.pageSize.height - 5,
                    { align: "right" }
                );
            },

            /*
             * This centers the table on the page
             */
            didParseCell: function (data) {
                if (data.section === "head") {
                    data.cell.styles.halign = "center";
                }
            },
        });

        doc.save("AR_Aging_Analysis_Lease.pdf");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Unit</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.unitNo}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label">As of</label>
                                <DatePicker
                                    selected={formData.asOf}
                                    onChange={(date) => handleDateChange({ name: 'asOf', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Lease Aging Analysis Report</h5>
                            <button style={{ cursor: exportGridData?.length > 0 ? 'pointer' : 'not-allowed' }} className="btn btn-primary" onClick={exportToPDF}>
                                Export as PDF
                            </button>
                            <button style={{ cursor: exportGridData?.length > 0 ? 'pointer' : 'not-allowed' }} className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>

                                <AgGridReact
                                    rowData={gridData}
                                    columnDefs={columnDefs}
                                    ref={gridRef}
                                    // pagination={true}
                                    // paginationPageSize={pageSize}
                                    defaultColDef={{
                                        sortable: true,
                                        filter: true,
                                        resizable: true,
                                    }}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default AgingAnalysis;